<mat-toolbar color="primary">
    <a [routerLink]="['/']" class="toolbar-link">
        <span>cicd.kubevirt-manager.io</span>
    </a>
</mat-toolbar>

<div class="container-fluid">

    <!-- GRAPHS -->
    <app-analytics></app-analytics>
    <br /><br />

    <!-- SELECTORS / FILTERS -->
    <div class="filters-container">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="...">
      </mat-form-field>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
          <mat-label>Project</mat-label>
          <mat-select [(ngModel)]="selectedProject" (selectionChange)="onProjectChange()">
          <mat-option *ngFor="let project of projects" [value]="project">{{ project }}</mat-option>
          </mat-select>
      </mat-form-field>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
          <mat-label>Branch</mat-label>
          <mat-select [(ngModel)]="selectedBranch" (selectionChange)="onBranchChange()">
          <mat-option *ngFor="let branch of branches" [value]="branch">{{ branch }}</mat-option>
          </mat-select>
      </mat-form-field>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline">
          <mat-label>Pipeline</mat-label>
          <mat-select [(ngModel)]="selectedPipeline" (selectionChange)="onPipelineChange()">
          <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline">{{ pipeline }}</mat-option>
          </mat-select>
      </mat-form-field>
    </div>

    <!-- PIPELINERUNS TABLE -->
    <mat-card>
      <mat-card-content>
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="error">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let log">
              <div *ngIf="log.error === 1; else errorIcon" class="status-success">
                <mat-icon>check_circle</mat-icon>
              </div>
              <ng-template #errorIcon>
                  <div class="status-error">
                    <mat-icon>cancel</mat-icon>
                  </div>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="pipelinerun">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PipelineRun </th>
            <td mat-cell *matCellDef="let log"> <a [routerLink]="['/details', log.pipelinerun]">{{log.pipelinerun}}</a> </td>
          </ng-container>
  
          <ng-container matColumnDef="pipeline">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Pipeline </th>
            <td mat-cell *matCellDef="let log"> {{log.pipeline}} </td>
          </ng-container>
  
          <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
            <td mat-cell *matCellDef="let log"> <a href="https://github.com/kubevirt-manager/{{log.project}}/">{{log.project}}</a> </td>
          </ng-container>
  
          <!--
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
            <td mat-cell *matCellDef="let log"> <a href="https://github.com/{{log.username}}/">{{log.username}}</a> </td>
          </ng-container>
           -->
          <ng-container matColumnDef="username">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
            <td mat-cell *matCellDef="let log">
              
              <ng-container *ngIf="log.username !== 'scheduled' && log.username !== 'manual'; else plainText">
                <a href="https://github.com/{{log.username}}/" target="_blank">{{log.username}}</a>
              </ng-container>

              <ng-template #plainText>
                <span>{{log.username}}</span>
              </ng-template>

            </td>
          </ng-container>
  
          <ng-container matColumnDef="gh_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Github # </th>
            <td mat-cell *matCellDef="let log"> <a href="https://github.com/kubevirt-manager/{{log.project}}/pull/{{log.gh_id}}">{{log.gh_id}}</a> </td>
          </ng-container>

          <ng-container matColumnDef="branch">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Branch </th>
            <td mat-cell *matCellDef="let log"> {{log.branch}} </td>
          </ng-container>

          <ng-container matColumnDef="lane">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Lane </th>
            <td mat-cell *matCellDef="let log"> {{log.lane}} </td>
          </ng-container>

          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Timestamp </th>
            <td mat-cell *matCellDef="let log"> {{log.processed_at | date: 'MM/dd/yyyy HH:mm'}} </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="footer-copyright">
    <div>
        Licensed under <a href="https://www.apache.org/licenses/LICENSE-2.0.html" style="font-weight:bold;">Apache License 2.0.</a>
    </div>
    <div>
        Copyright © 2022-2025 <span style="font-weight:bold;">KubeVirt Manager</span>.
    </div>
    <div>
        All rights reserved.
    </div>
  </div>

